import root from './root'
import './loader'
import './gm'
import './player'
import './plugins'

window.MIDI = root
export default root



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/